import { createActionGroup, emptyProps, props, createAction } from '@ngrx/store'
import {
    SelectionMode,
    FreeSelectionsForCase,
    SelectionType,
    FreeSelection,
    HierarchicalSelectionRoot,
    HierarchicalSelectionsForCase,
    UnsupervisedSelectionRoot,
} from './selection.state'
import { HttpErrorResponse } from '@angular/common/http'
import {
    FreeSelectionQueryParams,
    HierarchicalSelectionQueryParams,
} from '../../shared/model/query-params-types'

export const selectionActions = createActionGroup({
    source: 'Selection',
    events: {
        'Set Type': props<{ selectionType: SelectionType }>(),
        'Set Mode': props<{ mode: SelectionMode }>(),
        'Set Resolution': props<{ resolution: number }>(),
        'Update Selection': props<{ points: number[] }>(),
        'Clear Selection': emptyProps(),
        'Loading Free Selections Succeeded': props<{
            selections: FreeSelectionsForCase
            queryParams: FreeSelectionQueryParams
        }>(),
        'Loading Free Selections Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Loading Hierarchical Selection List Succeeded': props<{ list: string[] }>(),
        'Loading Hierarchical Selection List Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Hierarchical Selections Succeeded': props<{
            selections: HierarchicalSelectionsForCase
            queryParams: HierarchicalSelectionQueryParams
        }>(),
        'Loading Hierarchical Selections Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Unsupervised Selection List Succeeded': props<{ list: string[] }>(),
        'Loading Unsupervised Selection List Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Loading Unsupervised Selections Succeeded': props<{
            selections: HierarchicalSelectionsForCase
            queryParams: HierarchicalSelectionQueryParams
        }>(),
        'Loading Unsupervised Selections Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Set Free Selection': props<{ name: string | undefined }>(),
        'Set Free Selection Seg Source': props<{ segSource: string | undefined }>(),
        'Set Hierarchical Selection Root': props<{ name: string }>(),
        'Set Hierarchical Selection Node': props<{ name: string | undefined }>(),
        'Set Hierarchical Selection Root Seg Source': props<{ segSource: string | undefined }>(),
        'Set Auto Cell Type Detection Root': props<{ name: string }>(),
        'Set Auto Cell Type Detection Node': props<{ name: string | undefined }>(),
        'Set Auto Cell Type Detection Root Seg Source': props<{ segSource: string | undefined }>(),
        'Set Visible Selections On Scatter Plot': props<{ selectionNames: string[] }>(),
        'Save New Free Selection': props<{ name: string }>(),
        'Save Free Selection': emptyProps(),
        'Save New Hierarchical Selection Root': props<{
            name: string
            segSource: string | undefined
        }>(),
        'Save New Auto Cell Type Detection Root': props<{
            name: string
            segSource: string | undefined
        }>(),
        'Save New Hierarchical Selection Node': props<{ name: string }>(),
        'Save New Auto Cell Type Detection Node': props<{ name: string }>(),
        'Saving Free Selection Succeeded': props<{ selection: FreeSelection }>(),
        'Saving Free Selection Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Saving Hierarchical Selection Root Succeeded': props<{
            selection: HierarchicalSelectionRoot
        }>(),
        'Saving Hierarchical Selection Root Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Saving Auto Cell Type Detection Root Succeeded': props<{
            selection: UnsupervisedSelectionRoot
        }>(),
        'Saving Auto Cell Type Detection Root Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Delete Free Selection': emptyProps(),
        'Delete Hierarchical Selection Root': emptyProps(),
        'Delete Auto Cell Type Detection Root': emptyProps(),
        'Delete Hierarchical Selection Node': emptyProps(),
        'Delete Hierarchical Selection Node Recursively': emptyProps(),
        'Delete Auto Cell Type Detection Node': emptyProps(),
        'Delete Auto Cell Type Detection Node Recursively': emptyProps(),
        'Deleting Free Selection Succeeded': emptyProps(),
        'Deleting Free Selection Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Deleting Hierarchical Selection Root Succeeded': emptyProps(),
        'Deleting Hierarchical Selection Root Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Deleting Auto Cell Type Detection Root Succeeded': emptyProps(),
        'Deleting Auto Cell Type Detection Root Failed': props<{
            error: HttpErrorResponse
            message: string
        }>(),
        'Set Selection Visibility': props<{
            selectionName: string | undefined
            selectionType: SelectionType
            selectionRoot: string | undefined
            visible: boolean
        }>(),
        'Set Selection Opacity': props<{
            selectionName: string | undefined
            selectionType: SelectionType
            selectionRoot: string | undefined
            opacity: number
        }>(),
        'Set Selection Shader Color': props<{
            selectionName: string | undefined
            selectionType: SelectionType
            selectionRoot: string | undefined
            color: string
        }>(),
        'Set Search Key': props<{ searchKey: string }>(),
    },
})

export const noOpAction = createAction('[No Operation] No Operation')
